export const GOOGLE_FONT_NAMES: Record<string, string> = {
  '"Readex Pro", system-ui, sans-serif': "Readex+Pro",
  "Inter, system-ui, sans-serif": "Inter",
  "Poppins, sans-serif": "Poppins",
  "Roboto, sans-serif": "Roboto",
  "Open Sans, sans-serif": "Open+Sans",
  "Lato, sans-serif": "Lato",
  "Montserrat, sans-serif": "Montserrat",
  "Nunito, sans-serif": "Nunito",
};

